/**
 * 枚举类：秒杀会场活动状态
 */
module.exports = {

  STATE_BEGIN: {
    name: '已开始',
    value: 10
  },

  STATE_SOON: {
    name: '未开始',
    value: 20
  },

  STATE_END: {
    name: '已结束',
    value: 30
  },

};